export default function headerButtons() {

  var selectedCategory = $('.header-categories').data('selected');

  $.each($('.header-categories').children(), function (index, item) {
    if ($(item).data("type") === selectedCategory) {
      $(item).addClass('active')
    } else {
      $(item).removeClass('active')
    }
  });
};


// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/header_buttons.js